<template>
    <div id="scanner_setting_details"
        :style="{
            color: theme.color.font
        }">
        <div v-dropdown class="ui fluid selection dropdown no top border"
            v-if="this.$store.state.current_scope != 'customer'"
            :style="{
                background: (theme.background) ? theme.background : 'none',
                color: theme.color.font
            }">
            <div class="text">
                <!-- 當前狀態條碼： -->
                {{ $t('ui.scanner.helps.current_scan_action_prototype') }}：
                <span v-if="current_scan_action_prototype.identity">
                    {{ current_scan_action_prototype.name + '(' + current_scan_action_prototype.barcode + ')' }}
                </span>
                <span v-else>
                    <!-- 未選擇 -->
                    {{ $t('ui.general.no') }}
                    {{ $t('ui.general.select') }}
                </span>
            </div>

            <i class="dropdown icon"></i>
            <div class="menu"
                :style="{
                    background: (theme.background) ? theme.background : 'none',
                }">
                <div
                    v-for="status_prototype in scan_action_prototypes"
                    @click="$bus.$emit('set_current_scan_action_prototype', status_prototype.identity)"
                    class="item"
                    :style="{
                        color: theme.color.font,
                        background: (status_prototype.identity == current_scan_action_prototype.identity) ? 'rgba(0,0,0,.5)' : '',
                    }">
                    {{ status_prototype.name }}({{ status_prototype.barcode }})
                </div>
            </div>
        </div>

        <!-- Settings -->

        <div class="ui doubling five column grid settings"
            :class="{'inverted': is_inverted}"
            style="margin-top:0.1rem; margin-bottom:0.2rem;"
            >
            <div
                v-if="$store.getters[$store.state.current_scope+'/scanner_module/is_can_use_setting']('is_scan_action_mode')"
                class="column center aligned pointer setting"
                :class="{'active': settings.is_scan_action_mode}"
                @click="settings.is_scan_action_mode = !settings.is_scan_action_mode">
                <i class="big icons">
                    <i class="icon"
                        :class="{
                            'barcode': settings.is_scan_action_mode,
                            'eye': !settings.is_scan_action_mode
                        }">
                    </i>
                </i>
                <p>
                    <!-- settings.is_scan_action_mode ? '點貨作業模式':'檢視資料模式' -->
                    {{
                        settings.is_scan_action_mode
                            ? $tc('ui.scanner.settings.is_scan_action_mode.true')
                            : $tc('ui.scanner.settings.is_scan_action_mode.false')
                    }}
                </p>
            </div>

            <div
                v-if="$store.getters[$store.state.current_scope+'/scanner_module/is_can_use_setting']('is_distributed_to_mode')"
                class="column center aligned pointer setting"
                :class="{'active': settings.is_distributed_to_mode}"
                @click="settings.is_distributed_to_mode = !settings.is_distributed_to_mode">
                <i class="big icons">
                    <i class="external share icon"></i>
                    <i class="bottom left corner red dont icon"
                        v-if="!settings.is_distributed_to_mode">
                    </i>
                </i>
                <p>
                    <!-- settings.is_distributed_to_mode ? '分撥模式':'不分撥' -->
                    {{
                        settings.is_distributed_to_mode
                            ? $tc('ui.scanner.settings.is_distributed_to_mode.true')
                            : $tc('ui.scanner.settings.is_distributed_to_mode.false')
                    }}
                </p>
            </div>

            <div
                v-if="$store.getters[$store.state.current_scope+'/scanner_module/is_can_use_setting']('is_package_mode')"
                class="column center aligned pointer setting"
                :class="{'active': settings.is_package_mode}"
                @click="settings.is_package_mode = !settings.is_package_mode">
                <i class="big icons">
                    <i class="group object icon"></i>
                    <i class="bottom left corner red dont icon"
                        v-if="!settings.is_package_mode">
                    </i>
                </i>
                <p>
                    <!-- settings.is_package_mode ? '自動包裝':'不包裝' -->
                    {{
                        settings.is_package_mode
                            ? $tc('ui.scanner.settings.is_package_mode.true')
                            : $tc('ui.scanner.settings.is_package_mode.false')
                    }}
                </p>
            </div>

            <div
                v-if="$store.getters[$store.state.current_scope+'/scanner_module/is_can_use_setting']('is_unpackage_mode')"
                class="column center aligned pointer setting"
                :class="{'active': settings.is_unpackage_mode}"
                @click="settings.is_unpackage_mode = !settings.is_unpackage_mode">
                <i class="big icons">
                    <i class="ungroup object icon"></i>
                    <i class="bottom left corner red dont icon"
                        v-if="!settings.is_unpackage_mode">
                    </i>
                </i>
                <p>
                    <!-- settings.is_unpackage_mode ? '自動拆包':'不拆包' -->
                    {{
                        settings.is_unpackage_mode
                            ? $tc('ui.scanner.settings.is_unpackage_mode.true')
                            : $tc('ui.scanner.settings.is_unpackage_mode.false')
                    }}
                </p>
            </div>

            <!-- <div
                v-if="$store.getters[$store.state.current_scope+'/scanner_module/is_can_use_setting']('imitate_mode')"
                class="column center aligned pointer setting"
                :class="{'active': settings.imitate_mode}"
                @click="settings.imitate_mode = !settings.imitate_mode">
                <i class="big icons">
                    <i class="clipboard icon"></i>
                    <i class="bottom left corner red dont icon"
                        v-if="!settings.imitate_mode">
                    </i>
                </i>
                <p>
                    settings.imitate_mode ? '必填資料快速套用':'關閉快速套用'
                    {{
                        settings.imitate_mode
                        ? '必填資料快速套用'
                        :'關閉快速套用'
                    }}
                </p>
            </div> -->

            <div
                v-if="$store.getters[$store.state.current_scope+'/scanner_module/is_can_use_setting']('is_auto_print_label_mode')"
                class="column center aligned pointer setting"
                :class="{'active': settings.is_auto_print_label_mode}"
                @click="settings.is_auto_print_label_mode = !settings.is_auto_print_label_mode">
                <i class="big icons">
                    <i class="print icon"></i>
                    <i class="bottom left corner red dont icon"
                        v-if="!settings.is_auto_print_label_mode">
                    </i>
                </i>
                <p>
                    <!-- settings.is_auto_print_label_mode ? '自動產標':'不產標籤' -->
                    {{
                        settings.is_auto_print_label_mode
                            ? $tc('ui.scanner.settings.is_auto_print_label_mode.true')
                            : $tc('ui.scanner.settings.is_auto_print_label_mode.false')
                    }}
                </p>
            </div>

            <div
                v-if="$store.getters[$store.state.current_scope+'/scanner_module/is_can_use_setting']('is_print_small_label_of_any_number_mode')"
                class="column center aligned pointer setting"
                :class="{'active': settings.is_print_small_label_of_any_number_mode}"
                @click="settings.is_print_small_label_of_any_number_mode = !settings.is_print_small_label_of_any_number_mode">
                <i class="big icons">
                    <i class="barcode icon"></i>
                    <i class="bottom left corner red dont icon"
                        v-if="!settings.is_print_small_label_of_any_number_mode">
                    </i>
                </i>
                <p>
                    <!-- settings.is_print_small_label_of_any_number_mode ? '自動產標':'不產標籤' -->
                    {{
                        settings.is_print_small_label_of_any_number_mode
                            ? $tc('ui.scanner.settings.is_print_small_label_of_any_number_mode.true')
                            : $tc('ui.scanner.settings.is_print_small_label_of_any_number_mode.false')
                    }}
                </p>
            </div>

            <div
                v-if="$store.getters[$store.state.current_scope+'/scanner_module/is_can_use_setting']('is_reload_core_waybill_mode')"
                class="column center aligned pointer setting"
                :class="{'active': settings.is_reload_core_waybill_mode}"
                @click="settings.is_reload_core_waybill_mode = !settings.is_reload_core_waybill_mode">
                <i class="big icons">
                    <i class="refresh icon"></i>
                    <i class="bottom left corner red dont icon"
                        v-if="!settings.is_reload_core_waybill_mode">
                    </i>
                </i>
                <p>
                    <!-- settings.is_reload_core_waybill_mode ? '自動產標':'不產標籤' -->
                    {{
                        settings.is_reload_core_waybill_mode
                            ? $tc('ui.scanner.settings.is_reload_core_waybill_mode.true')
                            : $tc('ui.scanner.settings.is_reload_core_waybill_mode.false')
                    }}
                </p>
            </div>

            <!-- <div
                v-if="$store.getters[$store.state.current_scope+'/scanner_module/is_can_use_setting']('is_high_performance_mode')"
                class="column center aligned pointer setting"
                :class="{'active': settings.is_high_performance_mode}"
                @click="settings.is_high_performance_mode = !settings.is_high_performance_mode">
                <i class="big icons">
                    <i class="line chart icon"></i>
                    <i class="bottom left corner red dont icon"
                        v-if="!settings.is_high_performance_mode">
                    </i>
                </i>
                <p>
                settings.is_high_performance_mode ? '高效能模式':'一般模式'
                    {{
                        settings.is_high_performance_mode
                        ? $tc('ui.scanner.settings.is_scan_action_mode.true')
                        :'一般模式'
                    }}
                </p>
            </div> -->

            <div
                v-if="$store.getters[$store.state.current_scope+'/scanner_module/is_can_use_setting']('is_scan_mode')"
                class="column center aligned pointer setting"
                :class="{'active': settings.is_scan_mode}"
                @click="settings.is_scan_mode = !settings.is_scan_mode">
                <i class="big icons">
                    <i class="write icon"></i>
                    <i class="bottom left corner red dont icon"
                        v-if="settings.is_scan_mode">
                    </i>
                </i>
                <p>
                    <!-- settings.is_scan_mode ? '掃描模式':'手動模式' -->
                    {{
                        settings.is_scan_mode
                            ? $tc('ui.scanner.settings.is_scan_mode.true')
                            : $tc('ui.scanner.settings.is_scan_mode.false')
                        }}
                </p>
            </div>

            <div
                v-if="$store.getters[$store.state.current_scope+'/scanner_module/is_can_use_setting']('is_core_waybill_creation_mode')"
                class="column center aligned pointer setting"
                :class="{'active': settings.is_core_waybill_creation_mode}"
                @click="settings.is_core_waybill_creation_mode = !settings.is_core_waybill_creation_mode">
                <i class="big icons">
                    <i class="file word icon"></i>
                    <i class="bottom left corner red dont icon"
                        v-if="!settings.is_core_waybill_creation_mode">
                    </i>
                </i>

                <p>
                    <!-- settings.is_core_waybill_creation_mode ? '創單':'不創單' -->
                    {{
                        settings.is_core_waybill_creation_mode
                            ? $tc('ui.scanner.settings.is_core_waybill_creation_mode.true')
                            : $tc('ui.scanner.settings.is_core_waybill_creation_mode.false')
                    }}
                </p>
            </div>

            <div
                v-if="$store.getters[$store.state.current_scope+'/scanner_module/is_can_use_setting']('is_webcam_mode')"
                class="column center aligned pointer setting"
                :class="{'active': settings.is_webcam_mode}"
                @click="settings.is_webcam_mode = !settings.is_webcam_mode">
                <i class="big icons">
                    <i class="camera icon"></i>
                    <i class="bottom left corner red dont icon"
                        v-if="!settings.is_webcam_mode">
                    </i>
                </i>

                <p>
                    <!-- settings.is_webcam_mode ? '相機':'關閉相機' -->
                    {{
                        settings.is_webcam_mode
                            ? $tc('ui.scanner.settings.is_webcam_mode.true')
                            : $tc('ui.scanner.settings.is_webcam_mode.false')
                    }}
                </p>
            </div>

            <div
                v-if="$store.getters[$store.state.current_scope+'/scanner_module/is_can_use_setting']('is_noty_audio_mode')"
                class="column center aligned pointer setting"
                :class="{'active': settings.is_noty_audio_mode}"
                @click="settings.is_noty_audio_mode = !settings.is_noty_audio_mode">
                <i class="big icons">
                    <i class="volume up icon"></i>
                    <i class="bottom left corner red dont icon"
                        v-if="!settings.is_noty_audio_mode">
                    </i>
                </i>

                <p>
                    <!-- settings.is_noty_audio_mode ? '提示聲模式':'靜音模式' -->
                    {{
                        settings.is_noty_audio_mode
                            ? $tc('ui.scanner.settings.is_noty_audio_mode.true')
                            : $tc('ui.scanner.settings.is_noty_audio_mode.false')
                    }}
                </p>
            </div>

            <div
                v-if="$store.getters[$store.state.current_scope+'/scanner_module/is_can_use_setting']('is_speech_mode')"
                class="column center aligned pointer setting"
                :class="{'active': settings.is_speech_mode}"
                @click="settings.is_speech_mode = !settings.is_speech_mode">
                <i class="big icons">
                    <i class="file audio outline icon"></i>
                    <i class="bottom left corner red dont icon"
                        v-if="!settings.is_speech_mode">
                    </i>
                </i>

                <p>
                    <!-- settings.is_speech_mode ? '語音報件模式':'靜音語音報件' -->
                    {{
                        settings.is_speech_mode
                            ? $tc('ui.scanner.settings.is_speech_mode.true')
                            : $tc('ui.scanner.settings.is_speech_mode.false')
                    }}
                </p>
            </div>

            <div
                v-if="$store.getters[$store.state.current_scope+'/scanner_module/is_can_use_setting']('is_core_waybill_pieces_mode')"
                class="column center aligned pointer setting"
                :class="{'active': settings.is_core_waybill_pieces_mode}"
                @click="settings.is_core_waybill_pieces_mode = !settings.is_core_waybill_pieces_mode">
                <i class="big icons">
                    <i class="cubes icon" style="width: 34px;"></i>
                    <i class="bottom left corner red dont icon"
                        v-if="!settings.is_core_waybill_pieces_mode">
                    </i>
                </i>

                <p>
                    <!-- settings.is_core_waybill_pieces_mode ? '多件一單': '非多件一單' -->
                    {{
                        settings.is_core_waybill_pieces_mode
                            ? $tc('ui.scanner.settings.is_core_waybill_pieces_mode.true')
                            : $tc('ui.scanner.settings.is_core_waybill_pieces_mode.false')
                    }}
                </p>
            </div>

            <div
                v-if="$store.getters[$store.state.current_scope+'/scanner_module/is_can_use_setting']('is_quick_corewaybill_related_columns_mode')"
                class="column center aligned pointer setting"
                :class="{'active': settings.is_quick_corewaybill_related_columns_mode}"
                @click="settings.is_quick_corewaybill_related_columns_mode = !settings.is_quick_corewaybill_related_columns_mode">
                <i class="big icons">
                    <i class="paste up icon"></i>
                    <i class="bottom left corner red dont icon"
                        v-if="!settings.is_quick_corewaybill_related_columns_mode">
                    </i>
                </i>

                <p>
                    <!-- settings.is_quick_corewaybill_related_columns_mode ? '快速套用欄位':'不快速套用' -->
                    {{
                        settings.is_quick_corewaybill_related_columns_mode
                            ? $tc('ui.scanner.settings.is_quick_corewaybill_related_columns_mode.true')
                            : $tc('ui.scanner.settings.is_quick_corewaybill_related_columns_mode.false')
                    }}
                </p>
            </div>

            <div
                v-if="$store.getters[$store.state.current_scope+'/scanner_module/is_can_use_setting']('is_batch_mode')"
                class="column center aligned pointer setting"
                :class="{'active': settings.is_batch_mode}"
                @click="settings.is_batch_mode = !settings.is_batch_mode">
                <i class="big icons">
                    <i class="copy outline icon"></i>
                    <i class="bottom left corner red dont icon"
                        v-if="!settings.is_batch_mode">
                    </i>
                </i>

                <p>
                    <!-- settings.is_batch_mode ? '批次批次處理':'不批次處理' -->
                    {{
                        settings.is_batch_mode
                            ? $tc('ui.scanner.settings.is_batch_mode.true')
                            : $tc('ui.scanner.settings.is_batch_mode.false')
                    }}
                </p>
            </div>

            <div
                v-if="$store.getters[$store.state.current_scope+'/scanner_module/is_can_use_setting']('is_update_core_waybill_mode')"
                class="column center aligned pointer setting"
                :class="{'active': settings.is_update_core_waybill_mode}"
                @click="settings.is_update_core_waybill_mode =
                    (settings.imitate_mode) ? false : !settings.is_update_core_waybill_mode">
                <i class="big icons">
                    <i class="edit icon"></i>
                    <i class="bottom left corner red dont icon"
                        v-if="!settings.is_update_core_waybill_mode">
                    </i>
                    <i class="top left corner red lock icon"
                        style="top:6px; left:-6px;"
                        v-if="settings.imitate_mode">
                    </i>
                </i>
                <p>
                    {{
                        settings.is_update_core_waybill_mode
                            ? $tc('ui.scanner.settings.is_update_core_waybill_mode.true')
                            : $tc('ui.scanner.settings.is_update_core_waybill_mode.false')
                    }}
                </p>
            </div>

            <div
                v-if="$store.getters[$store.state.current_scope+'/scanner_module/is_can_use_setting']('core_waybill_template_mode')"
                class="column center aligned pointer setting"
                :class="{'active': settings.core_waybill_template_mode == 'min_card'}"
                @click="settings.core_waybill_template_mode = 'min_card'">
                <!--
                @click="settings.core_waybill_template_mode =
                    (settings.imitate_mode) ? 'card' : 'min_card'">
                -->
                <i class="big icons">
                    <i class="icon minus"></i>
                    <!-- <i class="top left corner red lock icon"
                        style="top:6px; left:-6px;"
                        v-if="settings.imitate_mode">
                    </i> -->
                </i>
                <p>
                    <!-- 極簡運單檢視 -->
                    {{ $tc('ui.scanner.settings.core_waybill_template_mode.min_card') }}
                </p>
            </div>
            <div
                v-if="$store.getters[$store.state.current_scope+'/scanner_module/is_can_use_setting']('core_waybill_template_mode')"
                class="column center aligned pointer setting"
                :class="{'active': settings.core_waybill_template_mode == 'card'}"
                @click="settings.core_waybill_template_mode = 'card'">
                <i class="big icons">
                    <i class="icon list"></i>
                    <!-- <i class="top left corner red lock icon"
                        style="top:6px; left:-6px;"
                        v-if="settings.imitate_mode">
                    </i> -->
                </i>
                <p>
                    <!-- 一般運單檢視 -->
                    {{ $tc('ui.scanner.settings.core_waybill_template_mode.card') }}
                </p>
            </div>
            <div
                v-if="$store.getters[$store.state.current_scope+'/scanner_module/is_can_use_setting']('core_waybill_template_mode')"
                class="column center aligned pointer setting"
                :class="{'active': settings.core_waybill_template_mode == 'detail'}"
                @click="settings.core_waybill_template_mode = 'detail'">
                <!-- @click="settings.core_waybill_template_mode =
                    (settings.imitate_mode) ? 'card' : 'detail'"> -->
                <i class="big icons">
                    <i class="icon file text"></i>
                    <!-- <i class="top left corner red lock icon"
                        style="top:6px; left:-6px;"
                        v-if="settings.imitate_mode">
                    </i> -->
                </i>
                <p>
                    <!-- 詳細運單檢視 -->
                    {{ $tc('ui.scanner.settings.core_waybill_template_mode.detail') }}
                </p>
            </div>

        </div>
    </div>
</template>

<script>
export default {
    props: {
        is_inverted: {
            default: false,
            type: Boolean
        },
    },
    data() {
        return {
            is_setting: false,
        }
    },
    computed: {
        current_store() {
            return this.$store.state[this.$store.state.current_scope].scanner_module
        },
        theme() {
            return this.current_store.config.theme
        },
        can_use_settings() {
            return this.current_store.config.settings
        },
        scan_action_prototypes() {
            return this.current_store.scan_action_prototypes
        },
        current_scan_action_prototype() {
            return this.current_store.current_scan_action_prototype
        },
        settings() {
            return this.current_store.settings
        },
    },
    watch: {
    },
    mounted() {
    },
    methods: {
    },
    components: {
    },
}
</script>

<style lang="scss" scoped>
    #scanner_setting_details {
        .icon {
            color: white;
        }
        .grid.settings {
            background: none;
            margin-left: 0;
            margin-right: 0;
            overflow: hidden;
        }
        .grid.settings .column{
            & {
                opacity: 0.5;
                transition: all .2s ease-in-out;
            }
            &:hover {
                opacity: 1;
                transform: scale(1.2, 1.2);
                -webkit-transform:scale(1.2, 1.2); /* Chrome, Safari, Opera */
                -ms-transform:scale(1.2, 1.2); /* IE 9 */
            }
            &.active {
                opacity: 1;
            }
        }

        .dropdown.inverted {
            &, .text:not(.default) {
                background-color: var(--inverted-color);
                color: white !important;
            }
            .item {
                background-color: var(--inverted-color);
                color: white ;
            }
        }
    }
    @media only screen and (max-width: 767px) {
        #scanner_setting_details {
            & {
                max-height: 60vh;
                overflow-x: hidden;
                overflow-y: scroll;
            }
            .ui.selection {
                font-size: 120%;
            }
            .ui.selection .menu {
                max-height: 15rem;
            }
            .ui.selection .item {
                font-size: 100%;
            }
            .grid.settings .column.setting {
                p {
                    font-size: 130%;
                }
                .icons {
                    zoom: 120%;
                }
            }
        }
    }

</style>
